import { OutliersPlType } from 'widgets/outliers/store/config/OutliersConfigState';
import Order, { OrderColumn } from 'communication/types/order/Order';
import { realisedPnlStrategy } from 'widgets/outliers/data/pnlStrategies/realised';
import { unrealisedPnlStrategy } from 'widgets/outliers/data/pnlStrategies/unrealised';
import { totalPnlStrategy } from 'widgets/outliers/data/pnlStrategies/total';

export interface OutliersPnlData {
    pnl: number;
    benchmarkPerformance: number;
}

export interface OutliersPnlStrategy {
    mapOrder: (
        order: Order,
        benchmarkPrice: number | undefined,
        exchangeRate: number
    ) => OutliersPnlData | undefined;
    requiredColumns: OrderColumn[];
}

export const pnlStrategies: Record<OutliersPlType, OutliersPnlStrategy> = {
    realised: realisedPnlStrategy,
    unrealised: unrealisedPnlStrategy,
    total: totalPnlStrategy,
};
